import { ReactNode } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from '../contexts/AuthContext'
import { AdminSocketProvider } from '../contexts/AdminSocketContext'
import { GoogleMapsProvider } from '@pocketbloom/shared-ui'
import { Toaster } from 'sonner'

type AppProvidersProps = {
  children: ReactNode
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 2,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: (failureCount, error: any) => {
        // Biznes xətalarını (4xx) təkrarlama — təkrar mənasızdır
        const status = error?.response?.status
        if (status && status >= 400 && status < 500) return false
        return failureCount < 1
      },
    },
  },
})

export function AppProviders({ children }: AppProvidersProps) {
  const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || ''

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <AdminSocketProvider>
            <GoogleMapsProvider apiKey={apiKey} language="az" libraries={['places', 'geometry', 'drawing']}>
              {children}
              <Toaster position="top-right" richColors />
            </GoogleMapsProvider>
          </AdminSocketProvider>
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  )
}


